// extracted by mini-css-extract-plugin
export default {"badgeStyles":"ChooseFenceDialog_badgeStyles__Gyc9Y"};